module.exports = __webpack_public_path__ + "static/media/workboard.db4d5d8c.png";